import { render, staticRenderFns } from "./BulletsIcon.vue?vue&type=template&id=2be6f45a&"
import script from "./BulletsIcon.vue?vue&type=script&lang=js&"
export * from "./BulletsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports